<template>
    <div class="blog_details_section" :style="'min-height:'+$minHeight+';'">
        <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
        <div class="container">
            <div class="row">
                <div class="col-lg-8 single-content">
                    <p class="mb-5">
                        <img v-bind:src="imagePath + blogDetail.image" alt="Image" class="img-fluid">
                    </p>
                    <h2 class="mb-4">
                        {{ blogDetail.title }}
                    </h2>
                    <!-- <div class="post-meta d-flex mb-5">
                        <div class="bio-pic mr-3">
                            <img src="assets/images/xperson_1.jpg.pagespeed.ic.Pkude8qe6Y.webp" alt="Image"
                                class="img-fluid">
                        </div>
                        <div class="vcard">
                            <span class="d-block"><a href="#">Dave Rogers</a> in <a href="#">News</a></span>
                            <span class="date-read">Jun 14 <span class="mx-1">•</span> 3 min read <span
                                    class="fa fa-star"></span></span>
                        </div>
                    </div> -->
                    <p v-html="blogDetail.long_detail"></p>
                    <!-- <div class="pt-5 categories_tags">
                        <p>Categories: <a href="#">Design</a>, <a href="#">Events</a> Tags: <a href="#">#html</a>, <a
                                href="#">#trends</a></p>
                    </div> -->
                    <div class="pt-5">
                        <!-- Leave a comment -->
                        <div class="comment-form-wrap pt-5">
                            <div class="section-title">
                                <h2 class="">Leave a comment</h2>
                            </div>
                            <form @submit.prevent="postComment" class="p-5 bg-light rounded-30">
                                <div class="form-group">
                                    <label for="name">Name *</label>
                                    <input type="text" class="form-control comment-form-wrap-input" id="name" v-model="name">
                                </div>
                                <div class="form-group">
                                    <label for="email">Email *</label>
                                    <input type="email" class="form-control comment-form-wrap-input" id="email" v-model="email">
                                </div>
                                <div class="form-group">
                                    <label for="website">Website</label>
                                    <input type="url" class="form-control comment-form-wrap-input" id="website" v-model="website">
                                </div>
                                <div class="form-group">
                                    <label for="message">Message</label>
                                    <textarea name="" id="message" class="form-control comment-form-wrap-input" v-model="message"></textarea>
                                </div>
                                <div class="form-group">
                                    <input type="submit" value="Post Comment" class="btn comment-form-wrap-btn py-3">
                                </div>
                            </form>
                        </div>
                        <!-- Leave a comment -->
                        <div class="section-title">
                            <h2 class="mb-0">Comments</h2>
                        </div>
                        <div v-if="!comments.length">
                            No comments found.
                        </div>
                        <ul class="comment-list">
                            <li class="comment" v-for="(row, index) in comments" :key="index">
                                <div class="vcard bio">
                                    <img src="blog/avatar.png" alt="image">
                                </div>
                                <div class="comment-body">
                                    <h3> {{ row.name }} </h3>
                                    <div class="meta"> {{ row.created_at | formatDate }} </div>
                                    <p> {{ row.message }} </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Popular Post -->
                <!-- <div class="col-lg-3 ml-auto">
                    <div class="section-title">
                        <h2>Popular Posts</h2>
                    </div>
                    <div class="trend-entry d-flex">
                        <div class="number align-self-start">01</div>
                        <div class="trend-contents">
                            <h2><a href="#">News Needs to Meet Its Audiences Where They Are</a></h2>
                            <div class="post-meta">
                                <span class="d-block"><a href="#">Dave Rogers</a> in <a href="#">News</a></span>
                                <span class="date-read">Jun 14 <span class="mx-1">•</span> 3 min read <span
                                        class="icon-star2"></span></span>
                            </div>
                        </div>
                    </div>
                    <div class="trend-entry d-flex">
                        <div class="number align-self-start">02</div>
                        <div class="trend-contents">
                            <h2><a href="#">News Needs to Meet Its Audiences Where They Are</a></h2>
                            <div class="post-meta">
                                <span class="d-block"><a href="#">Dave Rogers</a> in <a href="#">News</a></span>
                                <span class="date-read">Jun 14 <span class="mx-1">•</span> 3 min read <span
                                        class="icon-star2"></span></span>
                            </div>
                        </div>
                    </div>
                    <div class="trend-entry d-flex">
                        <div class="number align-self-start">03</div>
                        <div class="trend-contents">
                            <h2><a href="#">News Needs to Meet Its Audiences Where They Are</a></h2>
                            <div class="post-meta">
                                <span class="d-block"><a href="#">Dave Rogers</a> in <a href="#">News</a></span>
                                <span class="date-read">Jun 14 <span class="mx-1">•</span> 3 min read <span
                                        class="icon-star2"></span></span>
                            </div>
                        </div>
                    </div>
                    <div class="trend-entry d-flex pl-0">
                        <div class="number align-self-start">04</div>
                        <div class="trend-contents">
                            <h2><a href="#">News Needs to Meet Its Audiences Where They Are</a></h2>
                            <div class="post-meta">
                                <span class="d-block"><a href="#">Dave Rogers</a> in <a href="#">News</a></span>
                                <span class="date-read">Jun 14 <span class="mx-1">•</span> 3 min read <span
                                        class="icon-star2"></span></span>
                            </div>
                        </div>
                    </div>
                    <p>
                        <a href="#" class="more">See All Popular <span class="fa fa-arrow-right"></span></a>
                    </p>
                </div> -->
                <!-- Popular Post -->
            </div>
        </div>
        <!-- modal -->
        <!-- <div class="modal fade bd-example-modal-sm" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <form action="#" class="p-5 ">
                        <div class="form-group">
                            <label for="name">Name *</label>
                            <input type="text" class="form-control" id="name">
                        </div>
                        <div class="form-group">
                            <label for="email">Email *</label>
                            <input type="email" class="form-control" id="email">
                        </div>
                        <div class="form-group">
                            <label for="website">Website</label>
                            <input type="url" class="form-control" id="website">
                        </div>
                        <div class="form-group">
                            <label>Message</label>
                            <textarea name="" id="message" class="form-control"></textarea>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-success">Replied</button>
                            <button type="reset" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div> -->
        <!-- modal -->
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "BlogDetail",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            name: '',
            email: '',
            website: '',
            message: '',
            blogDetail: [],
            comments: [],
            imagePath: this.$api + "upload/blog/",
        }
    },
    created() {
        this.getBlogDetail(this.$route.params.id);
    },
    methods: {
        getBlogDetail: function(id) {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + this.$config.blog.detail + id
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.blogDetail = response.data.data.data;
                    this.comments = response.data.data.comments;
                }
                this.isLoading = false;
            }).catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Password and confirm password don't match!"
                });
            });
        },
        postComment: function() {
            this.isLoading = true;
            if(!this.name || !this.email || !this.website || !this.message) {
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter name, email, website and message!"
                });
            }
            else {
                this.isLoading = true;
                this.$axios.post(this.$api + "api/geek-blog-comments", {
                    blog_id: this.$route.params.id,
                    name: this.name,
                    email: this.email,
                    website: this.website,
                    message: this.message
                }).then((response) => {
                    console.log(response);
                    if(response.data.status == "success") {
                        this.isLoading = false;
                        this.$swal.fire({
                            icon: "success",
                            text: "Successfully stored data!"
                        });
                        this.name = '';
                        this.email = '';
                        this.website = '';
                        this.message = '';
                        this.getBlogDetail(this.$route.params.id);
                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.$swal.fire({
                            icon: "error",
                            text: "Failed! please try again."
                        });
                    }
                }).catch(error => {
                    console.log(error);
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                })
            }
        }
    }
}
</script>
